export const OVERRIDE_SSR_ORIGIN_COOKIE_NAME = "__holibob_ssr_origin";
